import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-view-all-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './view-all-button.html',
  styleUrl: './view-all-button.scss',
})
export class ViewAllButton {
  @Input() label: string = 'View all transactions';
  @Input() backgroundColor: string = 'var(--bg-primary2, white)';
  @Input() textColor: string = 'var(--color-primary1, black)';
}
